import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import UserApp from "./UserApp";
import store from "./store";

const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <UserApp />
  </Provider>,
);
